// extracted by mini-css-extract-plugin
export default {"wrapperCopyLink":"CopyLink_wrapperCopyLink__EE+Ua","imgCopyLink":"CopyLink_imgCopyLink__RfwmX"};